"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validationResultSchema = void 0;
var constants_1 = require("../../constants");
exports.validationResultSchema = {
    type: ['object', 'null'],
    additionalProperties: {
        not: true,
        errorMessage: '- should not have additional property ${0#}',
    },
    properties: {
        claimCompletenessResultCode: {
            type: 'integer',
            enum: Object.values(constants_1.ClaimCompletenessResultCode),
            errorMessage: 'Should equate to a valid ClaimCompletenessResultCode Enum value',
        },
        cmhcLoanAccountNumberMatchFlag: {
            type: 'boolean',
            errorMessage: 'Should be boolean',
        },
        formCompletenessResultFlag: {
            type: 'boolean',
            errorMessage: 'Should be boolean',
        },
        loanLevelValidationTypeCode: {
            type: 'integer',
            enum: Object.values(constants_1.LoanLevelValidationTypeCode),
            errorMessage: 'Should equate to a valid LoanLevelValidationTypeCode Enum value',
        },
        processClaimInMicsResultFlag: {
            type: 'boolean',
            errorMessage: 'Should be boolean',
        },
    },
};
